import container from '../../libs/container/container';
import preloader from "../../libs/preloader/preloader";
import scroll from "../../libs/scroll/scroll";

const amdLayoutModule = (function () {
    const name = 'layout';

    const view = container.getBaseView(name);

    view.privateVars = {

    };

    view.startup = function () {

        scroll.init({
            cssId: {
                headerCls: '.header'
            },
            fixedHeader: true
        });

        container.setService('scroll', scroll);

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.footerCls, 'animate__fadeIn', name, {
            dynamicPosHeight: true
        });


        preloader.setPreloadBulk(name, view.publicVars.preloadTab);
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

amdLayoutModule.init(window.extLayoutModuleConfig);